export class LoanRoleRelationshipsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanRoleRelationships({ companyId }) {
    return this.#http.get(`/api/companies/${companyId}/loanRoleRelations`);
  }

  async createLoanRoleRelationship({ companyId, body }) {
    return this.#http.post(`/api/companies/${companyId}/loanRoleRelations`, body);
  }

  async editLoanRoleRelationship({ companyId, id, body }) {
    return this.#http.put(`/api/companies/${companyId}/loanRoleRelations/${id}`, body);
  }

  async deleteLoanRoleRelationship({ companyId, id }) {
    return this.#http.delete(`/api/companies/${companyId}/loanRoleRelations/${id}`);
  }
}
